import i18next from 'i18next'
import { BigNumber } from 'bignumber.js'
import conf from '@/conf'

const {
    constant: {
        reduxAsyncCaseTypeMap
    }
} = conf

/**
 * 获取当前浏览器的语言
 * @returns {string}
 */
export const getBrowserLanguage = () =>
    // // const lang = navigator.language
// //
    // // // 英语区的使用美式英语
    // // if (lang.startsWith('en')) return 'en-US'
// //
    // // // 中文区的使用简体中文
    // // if (lang.startsWith('zh')) return 'zh-CN'
//
    // return lang
	 'zh-CN'


// 切换语言包
export const changeLanguage = async (lng) => {
    if (i18next.language !== lng) return await i18next.changeLanguage(lng)
    return Promise.resolve()
}

/**
 * 创建Action
 * @param action
 * @param reducerObj
 * @returns {{extraReducers: extraReducers, reducers: {}}}
 */
export const createActions = (reducerObj, action) => {
    const reducers = {}
    const ers = {}
	
    Object.entries(reducerObj).forEach(([fnName, v]) => {
        if (typeof v === 'function') reducers[fnName] = v
		
        if (typeof v === 'object') {
            const cs = []
            Object.entries(v).forEach(([t, fn]) => {
                const ak = reduxAsyncCaseTypeMap[t]
                if (ak && action[fnName]) cs.push({ type: ak, fn })
            })
	        
            ers[fnName] = cs
        }
    })
	
    const extraReducers = (builder) => {
        Object.entries(ers).forEach(([k, cs]) => {
            cs.forEach(({ type, fn }) => {
                builder.addCase(action[k][type], fn)
            })
        })
    }
	
    return {
        reducers,
        extraReducers
    }
}

export const loadRoutes = () => {
    const routes = []
    const routeContext = require.context('@/routers/routes', false, /\.js(x)$/)
	
    routeContext.keys().forEach((key) => {
        const context = routeContext(key)
        const route = context.default || context
		
        routes.push(...route)
    })
	
    return routes
}

export const stringToArray = (str) => str ? [str] : []

export const arrayToString = (arr) => arr.join()

export const getAttrValue = (obj, key, defaultValue = '--') =>( obj && obj[key]) || defaultValue

export const getPermissionsPathname = (routes, roles) => {
    let results = []
    routes.forEach(({ path, loader, children }) => {
        const data = path && loader && loader()
		
        if (data) {
            const { menuIndex, key } = data
			
            const item = { path, key, menuIndex }
			
            if (children && children.length > 0) {
                const c = getPermissionsPathname(children, roles)
	            if (c.length > 0) item.children = c
            }
			
            if ((item.children && item.children.length > 0) || roles.includes(data.key)) {
                results.push(item)
            }
        }
    })
    results = results.sort((a, b) => a.menuIndex - b.menuIndex).map(({ menuIndex, ...item }) => (item))
    return results
}

export const comparePathname = (routes, pathname) => {
    let isPermissions = false
    const pathItem = routes.find((r) => pathname.includes(r.path))
    if (pathItem) {
        if (pathItem.children && pathItem.children.length > 0) {
            isPermissions = comparePathname(pathItem.children, pathname)
        } else {
	        isPermissions = true
        }
    }
	
    return isPermissions
}

export const isUser = userLevel => userLevel === 1

export const addPrice = (price, tax) => new BigNumber(price).plus(new BigNumber(tax)).toString()

export const downloadFile = (buf, filename) => {
    const blob = new Blob([buf], { type: 'applicationnd.ms-excel'})
	
    if (!!window.ActiveXObject || 'ActiveXObject' in window) {
        window.navigator.msSaveOrOpenBlob(blob, filename)
    } else {
        const downloadElement = document.createElement("a")
        const href = window.URL.createObjectURL(blob)
        downloadElement.href = href
        downloadElement.textContent = 'textContent'
        downloadElement.download = filename
		
        document.body.appendChild(downloadElement)
        downloadElement.click()
        document.body.removeChild(downloadElement)
        window.URL.revokeObjectURL(href)
    }
}

/**
 * 判断当前环境是否为Electron客户端
 * @returns {boolean} 是否在Electron客户端中运行
 */
export const isElectron = () => {
    try {
        // 检查userAgent
        const userAgent = window?.navigator?.userAgent?.toLowerCase()
        if (userAgent && userAgent.indexOf('electron') !== -1) return true
        
        // 检查process.versions.electron
        if (window?.process?.versions?.electron) return true
        
        return false
    } catch (e) {
        return false
    }
}
